<mat-form-field>
    <mat-select [(value)]="config.defaultMetricId" (selectionChange)="applyMetricChange($event)">
        <mat-option *ngFor="let metricOption of config.options" [value]="metricOption.id">
            {{metricOption.displayName}}
        </mat-option>
    </mat-select>
</mat-form-field>